import {
    Component,
    Input,
    OnDestroy,
    ViewChild,
    EventEmitter,
    Output
} from '@angular/core';
import { GlobalSettings } from '../../../global.settings';
import { CommonService } from '../../../common.service';
import Utils from '../../../utils';
import { SharedService } from '../../../shared.service';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ApplicationService } from 'src/app/application.service';
import { Router } from '@angular/router';
import { UtilsService } from 'src/app/utils.service';

@Component({
    selector: 'app-tree-detail-search-list',
    templateUrl: './tree-detail-search-list.component.html',
    styleUrls: ['./tree-detail-search-list.component.scss' , '../../../common/tabular-tree-side-pane/tabular-tree-side-pane.component.scss']
})

export class TreeDetailSearchListComponent implements OnDestroy{

    // Search result is given as an input to see the list
    @Input() searchResult;
    // current selected tree tab for taxonomy details default false
    @Input() currentTreeTab = false;
    // Is node data loaded successfully
    dataLoaded = false;
    // Current item selected
    currentItem = null;
    // current clicked event search or etc.
    clicked = '';
    // Search result event triggered
    searchResultEvent: Subscription;
    // Current Accordian Search node
    currentAccordianSearch: any;
    // Alert messages to be shown
    alertMsgs: any;
    // right side panel loading data
    showAdditionalDataLoader = false;
    // node data to be sent for the right side
    nodeData: any = {};
    // total search Results
    totalSearchResults: any;
    // pagination count for the list
    pagination = GlobalSettings.ES_SEARCH_OFFSET;
    // total hit length
    totalHitResultCount: any;
    // hold fist page boolean data;
    firstPage : any = false;
    //hold pageRange object
    pageRangeData : any = {}
    //All API result
    searchApiResults : any = []
    //
    totalfetchedResult : any =0;

    //Add from taxonomy checkbox
    taxonomyCheckbox = this.router.url.indexOf('project/authoring') !== -1 
        ? true
        : false;
    // hold disable document checkbox
    disableDocument = false;
    // holds array of node ids selected from tree, for creating associations
    selectedNodeIds = [];
    // holds selected association from drop down
    selectedAssociationType = null;
    // holds requiredFullHierarchyFlag to identify if append or append with 
    // childs is selected
    requiredFullHierarchyFlag = null;
    // Search Triggerred
    searchTrigger = false;
    loadResultEvent: Subscription;
    showTaxonomyName = true;
    // acmt search currentTab
    @Input() currentTab;
    // input display option from association
    @Input() displayOption = '';
    // holds additional options to append or append with child nodes
    @Input() isCopy = false;
    // holds additional options to append or append with child nodes
    @Input() isCopyAssociation = false;
    // holds flag save is clicked on modal options to append with child nodes
    @Input() optionsToCopySaved = false;
    // input display text from association
    @Input() displayText = '';
    // holds the all selected node ids
    @Output() updatedAssociationsObj: EventEmitter<any>;
    //hold removed/reset options
    @Output() removeOptions: EventEmitter<any>;
    // holds boolean if settings modal is opened
    @Output() settingsModalOpen: EventEmitter<any>;
    // emit filter object
    @Output() resetSearchEvent = new EventEmitter();


    constructor(
        private service: CommonService,
        private sharedService: SharedService,
        private http: HttpClient,
        private applicationService: ApplicationService,
        private router: Router,
        private utilsService: UtilsService,

    ) {
        this.updatedAssociationsObj = new EventEmitter<any>();
        this.removeOptions = new EventEmitter<any>();
        this.settingsModalOpen = new EventEmitter<any>();
        this.searchResultEvent = this.sharedService.treeSearchResultEvent.subscribe(
            (item: any) => {
                if (item['showSearchList']) {
                    this.totalSearchResults = item.totalSearchResult;
                    this.totalHitResultCount = item.totalHitResultCount;
                    this.dataLoaded = true;
                    this.totalfetchedResult = item.searchApiResults
                        ? item.totalfetchedResult
                        : 0;
                    this.searchApiResults = item.searchApiResults 
                        ? item.searchApiResults 
                        : [];

                    this.pageRangeData = (this.totalfetchedResult > 0 ) 
                        ? item.pageRangeData 
                        : 0;

                    this.firstPage = (item.isFirstPage && this.totalfetchedResult <= this.pagination)
                        ? true
                        : false;

                    this.setAccordinaItem(item.searchData);
                        (this.router.url.indexOf('list') !== -1
                            || this.router.url.indexOf('project/detail') !== -1 || this.currentTreeTab)
                                ? this.utilsService.searchHeightCalculationList()
                                : this.utilsService.searchHeightCalculation();
                }
            }
            );

        this.getJSON().subscribe(data => {
            this.alertMsgs = data;
        });
    }

    /**
     * Tree Node selected item
     *
     * @param item item selected from the tree
     */
    async onTreeNodeSelected(item, treeHierarchy?) {
        this.currentItem = null;
        if (document.getElementById('mySidenavES'))
        {
            document.getElementById('mySidenavES').style.right = '0px';
        }
        this.currentItem = item;
        this.currentItem.taxonomyTitle = '';
        

        if(this.currentItem._source){
            this.currentItem.taxonomyTitle = item._source.title 
                ? item._source.title 
                : item._source.CFDocumentURI.title;
        }

        if(!this.currentItem._source)
        {
            this.currentItem.taxonomyTitle = treeHierarchy
                .filter(product =>
                    product.hasOwnProperty('document_id'))[0].title
        }

        this.showAdditionalDataLoader = true;
        const nodeDetails: any = {};
        nodeDetails.languages = await this.applicationService.getApplicationServiceData(
            false,
            'languageList'
        );
        nodeDetails.metaDataTaxonomyList = await this.applicationService.getApplicationServiceData(
            false,
            'taxonomyTypeMetatadata',
            '/random_id' + '?internal_name=Taxonomy Type'
        );
        const data: any = await this.applicationService.getApplicationServiceData(
            false,
            'nodeTypeList'
        );
        nodeDetails.nodetypeData = data?.nodetype;

        if(item.document_id){
            nodeDetails.document_id = item.document_id
        }
        else{
            nodeDetails.item_id = item.identifier
        }

        if(item._source){
            if(item._source.nodeType && item._source.nodeType === 'Document'){
                nodeDetails.document_id = item._source.document_id
                    ? item._source.document_id
                    :item._source.identifier
            }
            else{
                nodeDetails.item_id = item._source.item_id ? item._source.item_id : item._source.identifier
                // nodeDetails.item_id = item._source.Hierarchy.parent[0]
                //     ? item._source.Hierarchy.parent[0].identifier
                //     : item_identifier
            }
        }

        this.nodeData = Object.assign({} , nodeDetails);
    }

    /**
     * Functionality to get the result count Functionality to get the result count
     *
     * @returns the count of the result
     */
    getCount() {
        if (this.searchApiResults.length > 0)
        {
            const arr = this.searchApiResults
                .filter(x => x.type !== 'project');
            return arr.length;
        }
        return 0;
        
    }

    /**
     * navigate to the next page
     *
     * @param object item details
     */
    navigate(object, parent?) {
        let path = this.getNavigationPrefix();
        let item_identifier = object._source.identifier;
        if(object._source.item_id || object._source.document_id){
            item_identifier = object._source.item_id 
                ? object._source.item_id
                : object._source.document_id
        }

        let document_identifier = object._source.document_id
            ? object._source.document_id
            : object._source.identifier
        
        path = path 
            + ((object._source.Hierarchy && object._source.Hierarchy.document)
                ? object._source.Hierarchy.document.document_id
                : document_identifier)
            + '/'
            + ((object._source && object._source.item_id) ? object._source.item_id : item_identifier);

        this.openLinkInNewWindow(path);
    }

    /**
     * Set the Current Accordian search Item
     *
     * @param searchItem Current Search item
     */
    setAccordinaItem(searchArr) {
        searchArr.forEach((searchItem: any) => {
                let itemName = searchItem._source.fullStatement
                    ? searchItem._source.fullStatement
                    : searchItem._source.humanCodingScheme;

                if (searchItem._source.nodeType
                    && searchItem._source.nodeType === 'Document'
                ) {
                    itemName = searchItem._source.CFPackageURI.title;
                }

            Utils.googleAnalyticsEventCapture(
                'click',
                Utils.analyticsEvtName.elasticSearchBreadcrumb,
                this.getUserId() +
                '_' +
                searchItem._source.identifier +
                '_' +
                itemName
            );

        searchItem.parent_hierarchy = [];

        if (searchItem._source.Hierarchy) {
            searchItem.parent_hierarchy = this.flattenedHierarchyArray(
                searchItem._source.Hierarchy.parent
            );
            searchItem.parent_hierarchy.push(
                searchItem._source.Hierarchy.document
            );
        }
    });
}

    /**
     * Fetch the alert messages json
     *
     * @returns messages json
     */
    public getJSON(): Observable<any> {
        return this.http.get('./assets/json/messages.json');
    }

    /**
     * Closing the overlay panel navigation
     */
    closeNav(){
        if (document.getElementById('mySidenavES'))
        {
            document.getElementById('mySidenavES').style.right = '-250%';
        }
    }

    /**
     * generate the navigation url prefix
     *
     * @returns the navigation url prefix
     */
    getNavigationPrefix(){
        const urlPrefix = GlobalSettings.BASE_URL
            .replace('server/', Utils.baseTag + '#')
            .replace('api.', '');
        return urlPrefix + this.service.getOrgDetails() + '/' + Utils.ROUTE_TAXONOMY_DETAIL + '/';
    }

    /**
     * Open the path in the new window
     *
     * @param path path to open in a new window
     */
    openLinkInNewWindow(path){
        localStorage.setItem('association_link_clicked', 'true');
        const currentUrl = sessionStorage.getItem('current_url');
        const frontFaceUrl = sessionStorage.getItem('frontface_url');
        sessionStorage.clear();
        const win = window.open(path, '_blank');
        if (currentUrl && frontFaceUrl) {
            sessionStorage.setItem('current_url', currentUrl);
            sessionStorage.setItem('frontface_url', frontFaceUrl);
        }
        win?.focus();
        event.preventDefault();
    }

    /**
     * Tree node data fetched
     *
     * @param event event fired when the tree node data is fetched
     */
    treeNodeDataFetched(event: any) {
        if (event.detail !== 'false') {
            this.showAdditionalDataLoader = false;
        }
    }

    // get user id
    getUserId() {
        return localStorage.getItem('user_id') ? localStorage.getItem('user_id') : '';
    }

    ngOnDestroy() {
        if (this.searchResultEvent){
            this.searchResultEvent.unsubscribe();
        }
        this.currentItem = null;
    }

    // load more list in the search result
    loadMoreList(){
        this.sharedService.loadMoreSearchResult.next(true);
    }

    /**
     * Flattened the recursive tree array
     *
     * @param data taxonomyData
     *
     * @returns the flattened array for the recursive structure
     */
    flattenedHierarchyArray(data: any) {
        let result = [];
        data.forEach((a: any) => {
            result.push(a);
            if (Array.isArray(a.parent)) {
                result = result.concat(this.flattenedHierarchyArray(a.parent));
            }
        });
        return result;
    }
    
    /**
     * To push selected nodes into main array
     *
     * @param id         node id
     * @param isChecked  checked value
     * 
     * @return void
     */
    updatedSelection(id, isChecked) {
        if (isChecked) {
            this.selectedNodeIds.push(id);
        }
        this.emitSelectedNode();
    }
    /**
     *  Funtion for emit association on selected node
     * 
     * @return void
     */
    emitSelectedNode() {
        this.updatedAssociationsObj.emit({
            node: this.selectedNodeIds,
            associationType: this.selectedAssociationType,
            requiredFullHierarchyFlag: this.requiredFullHierarchyFlag,
            documentId: '',
        });
    }

    /**
     * Functionality to capture and emit event remove/reset copy options start
     *
     * @param evt  remove event
     *
     * @return void
     */
    removeCopiedOptions(evt) {
        this.removeOptions.emit(evt);
    }

    /**
     * Functionality to capture and emit selected association type start
     * 
     * @param evt event param for update
     * 
     * @return void
     */
    updateAssociationsObj(evt) {
        this.selectedAssociationType = null;
        if (evt.associationType) {
            this.selectedAssociationType = evt.associationType;
        }

        this.deselectDocument(this.selectedAssociationType);
        this.requiredFullHierarchyFlag = evt.requiredFullHierarchyFlag;

        this.updatedAssociationsObj.emit({
            node: this.selectedNodeIds,
            associationType: this.selectedAssociationType,
            requiredFullHierarchyFlag: this.requiredFullHierarchyFlag,
            documentId: '',
        });
    }

    /**
     * Functionality to deselect and disable document result from list
     * 
     * @param selectedAssociationType selected association
     * 
     * @return void
     */
    deselectDocument(selectedAssociationType) {
        if ((selectedAssociationType
            && selectedAssociationType.type_name === 'isChildOf') 
            || selectedAssociationType === null
        ) {
            this.disableDocument = false;
            return;
        }

        if (!this.searchResult) {
            return;
        }

        this.disableDocument = true;
        this.searchResult.forEach((element) => {
            if (element.isChecked
                && document.getElementById('custom-check-' + element.unique_node_id)
                && element['type'][0] === 'document'
            ) {
                document
                    .getElementById('custom-check-' + element.unique_node_id)
                    .click();
            }
        });
    }
    
    /**
     * Functionality called on open of association append settings modal
     * 
     * @param event Selected option event
     * 
     * @return void
     */
    selectOptions(event) {
        this.settingsModalOpen.emit(true);
    }

    /**
     * Functionality for reset search option
     * 
     * @return void
     */
    resetSearch() {
        this.dataLoaded = false;
        this.sharedService.treeSearchResultEvent.next({
            'searchData': [],
            'showSearchList': false
        });
        this.disableDocument = false;
        this.resetSearchEvent.emit(true);
    }

    /**
     * Functionality to show Tree on Hover
     * 
     * @param  data     Parent Hierarchy data for iterate
     * 
     * @return string   Tree structure
     */
    showTitles(data){
        try{
            let titleString = "";
            for (let i = data.length - 1; i >= 2; i--) {
                if(!data[i].document_id){
                    titleString += ">" + (
                        data[i].human_coding_scheme  + " " + data[i].full_statement
                        );
                }
            }
            return titleString;
        }catch(e){
            return e;
        };
    };

    loadPrevList(){
        this.sharedService.loadMorePrevSearchResult.next(true);
    }
}